import styled from 'styled-components';
import { Dropdown, Container as ContainerSemantic } from 'semantic-ui-react';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';
import { SortableList } from '../../../../company/components/sortable-component';

export const DropdownRanking = styled(Dropdown)`
  &.ui.selection.dropdown {
    min-width: 1em;
    border: ${(props) => (props.error ? '0.1em solid red' : '0.1em solid black')};
  }

  &.ui.dropdown:not(.button)>.default.text {
    color: ${(props) => (props.error ? 'red' : 'black')};
  }
`;

export const Content = styled.div`
  display: flex;
  border: 0.1em solid black;
  gap: 1em;
  align-items: center;
  border-radius: 0.5em;
  padding: 0.5em;
`;

export const TextErrorRanking = styled(TextLayoutComponent.Error)`
  text-align: center;
`;

export const Text = styled(TextLayoutComponent)``;

export const SortableListRanking = styled(SortableList)`
  width: 100%;
  margin-top: 50px;
  &&&.ui.container {
    margin-left: 0;
  }
`;

export const ContainerRanking = styled(ContainerSemantic)`
  &.ui.container {
    width: 230px;
    margin-left: initial !important;
  }
`;

export const ItemLabel = styled(TextLayoutComponent.Label)`
  max-width: 110px;
  word-break: break-word;
`;
